<template>
  <a v-if="country === 16 || country === '16'"
      id="shaim_ares_button"
      class="btn btn-primary btn-lg btn-block"
      @click="loadShaimAresData"
  >{{ translations['Load data from ARES'] }}</a>
</template>
<script>

import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      identificationNumber: state => state.user.invoiceAddress.identificationNumber,
      country: state => state.user.invoiceAddress.country,
      config: state => state.config
    }),
  },
  methods: {
    loadShaimAresData: function () {
      if (this.validateIdentificationNumber(this.identificationNumber) === false) {
        return;
      }

      this.getData()
          .then((data) => {
            if (data.stav !== 'ok') {
              alert(data.stav);
              return;
            }

            const promises = [];

            if (!data.firma.match(/s\.r\.o\./) && !data.firma.match(/s r\.o\./)) {
              var jmeno_prijmeni = data.firma.split(' ');
              if (jmeno_prijmeni.length === 3) {
                jmeno_prijmeni[0] = jmeno_prijmeni[1];
                jmeno_prijmeni[1] = jmeno_prijmeni[2]
              }
              promises.push(this.$store.dispatch('UPDATE_INVOICE_FIRSTNAME', jmeno_prijmeni[0]));
              promises.push(this.$store.dispatch('UPDATE_INVOICE_LASTNAME', jmeno_prijmeni[1]));
            }
            promises.push(this.$store.dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', data.ico));
            promises.push(this.$store.dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', data.dic));
            promises.push(this.$store.dispatch('UPDATE_INVOICE_COMPANY', data.firma));
            promises.push(this.$store.dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', data.ulice));
            promises.push(this.$store.dispatch('UPDATE_INVOICE_CITY', data.mesto));
            promises.push(this.$store.dispatch('UPDATE_INVOICE_POSTAL_CODE', data.psc));

            alert(this.translations['Fields was filled with data from ARES'])

            return Promise.all(promises);
          })
    },
    getData () {
      const secureKey = this.config.modules.shaim_ares.secure_key;
      return fetch(window.base_uri+'/modules/shaim_ares/shaim_ares_ajax.php?rand='+new Date().getTime()+'&dni='+this.identificationNumber+'&pass=shaim&_='+new Date().getTime()+'&secure_key='+secureKey, {credentials: "include"})
          .then((response) => {
            return response.json();
          }).catch((error) => {
            alert('ARES database is not available right now. Please enter your data manually');
          })
    },
    validateIdentificationNumber (identificationNumber) {
      if (identificationNumber === '') {
        alert(this.translations['Identification number is empty']);
        return false;
      }
      if (identificationNumber.length <= 6) {
        alert(this.translations['Identification number is too short']);
        return false;
      }
      if (identificationNumber.length > 8) {
        alert(this.translations['Identification number is too long. Maximal length is 8 characters']);
        return false;
      }
      if (identificationNumber.match(/[0-9]/) === null) {
        alert(this.translations['Identification number should contains numbers only']);
        return false;
      }
      return true;
    }
  },
}
</script>
<style>
  #shaim_ares_button {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
</style>